import { makeDataStore } from '../y/data-store';
import { YId, YFlags } from '../y/types';
import { LPermission } from './l-permission';
import { LScope } from './l-scope';

export interface LAccessKey {
    id: YId;
    name: string;

    scope: LScope;
    permissions: YFlags<LPermission>;

    secret?: string;
}

export const l_access_keys = makeDataStore('access_keys', 'access_key', (m: LAccessKey) => m, Object.assign);
